import axios, { AxiosError } from "axios";
import { useQuery } from "react-query";
import { API_URL } from "../consts";
import * as React from "react";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "@mui/utils";
import { format } from "date-fns";
import { Dialog, Stack, TextField, useMediaQuery } from "@mui/material";
import { Order, stableSort, getComparator } from "../ui/Tables";
import { oraPrenotaStore } from "../oraPrenotaStore";
import { useEffect, useState } from "react";
import { Loading } from "../ui/Loading";
import { uiStore } from "../uiStore";
import { DatePicker } from "@mui/x-date-pickers";
import { readDate } from "../utils/dateUtils";
import { ViewPrenotazione } from "./ViewPrenotazione";
import IconButton from "@mui/material/IconButton";
import InfoIcon from "@mui/icons-material/Info";
import { useTheme } from "@mui/material/styles";

interface Data {
  idPrenotazione: number;
  idPrentPartecip: number;
  denominazione: string;
  dataFinePrenotazione: string;
  dataInizioPrenotazione: string;
  cognome: string;
  codiceSocio: string;
  descrizioneUso: string;
  dataInserimento: string;
  annullabile: number;
}
interface HeadCell {
  disablePadding: boolean;
  id: keyof Data;
  label: string;
  numeric: boolean;
  key: string;
  filter: boolean;
}

const headCells: readonly HeadCell[] = [
  {
    id: "idPrenotazione",
    numeric: false,
    disablePadding: false,
    label: "",
    key: "ID2",
    filter: false,
  },
  {
    id: "idPrenotazione",
    numeric: false,
    disablePadding: false,
    label: "Id",
    key: "ID",
    filter: true,
  },
  {
    id: "denominazione",
    numeric: false,
    disablePadding: false,
    label: "Risorsa",
    key: "denominazioneris",
    filter: true,
  },
  {
    id: "dataInizioPrenotazione",
    numeric: false,
    disablePadding: false,
    label: "Giorno",
    key: "Giorno",
    filter: true,
  },
  {
    id: "dataInizioPrenotazione",
    numeric: false,
    disablePadding: false,
    label: "Inizio",
    key: "Inizio",
    filter: true,
  },
  {
    id: "dataFinePrenotazione",
    numeric: false,
    disablePadding: false,
    label: "Fine",
    key: "Fine",
    filter: true,
  },
  {
    id: "codiceSocio",
    numeric: false,
    disablePadding: false,
    label: "Codice Prenotante",
    key: "codiceSocio",
    filter: true,
  },
  {
    id: "codiceSocio",
    numeric: false,
    disablePadding: false,
    label: "Nominativo Prenotante",
    key: "nominativo",
    filter: true,
  },
  {
    id: "descrizioneUso",
    numeric: false,
    disablePadding: false,
    label: "Utilizzo",
    key: "descrizioneUso",
    filter: true,
  },
  {
    id: "dataInserimento",
    numeric: false,
    disablePadding: false,
    label: "Data Inserimento",
    key: "dataInserimento",
    filter: true,
  },
];

interface EnhancedTableProps {
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof Data) => void;
  order: Order;
  orderBy: string;
  rowCount: number;
  onFilter: (event: any, property: keyof Data, filter: string | number) => void;
}

function EnhancedTableHead(props: EnhancedTableProps) {
  const { order, orderBy, onRequestSort, onFilter } = props;
  const createSortHandler = (property: keyof Data) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };
  const createFilterHandler = (property: keyof Data) => (event: any) => {
    onFilter(event, property, event.target.value);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.key}
            align={headCell.numeric ? "right" : "left"}
            padding={headCell.disablePadding ? "none" : "normal"}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.label !== "" && (
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : "asc"}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === "desc" ? "sorted descending" : "sorted ascending"}
                  </Box>
                ) : null}
              </TableSortLabel>
            )}
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell key={headCell.key ? headCell.key : headCell.id}>
            {headCell.filter && (
              <TextField label="" variant="standard" onChange={createFilterHandler(headCell.id)} />
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

export function VisualizzaPrenotazioni() {
  const inizio = new Date(new Date().getFullYear(), 0, 1);
  let fine = new Date();
  fine.setTime(fine.getTime() + 24 * 3600 * 1e3);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [dataInizio, setDataInizio] = useState<Date | null>(inizio);
  const [dataFine, setDataFine] = useState<Date | null>(fine);

  const dataInizio2 = new Date();
  if (dataInizio) dataInizio2.setDate(dataInizio.getDate());
  dataInizio2.setUTCHours(0);
  dataInizio2.setUTCMinutes(0);
  dataInizio2.setSeconds(0);
  dataInizio2.setMilliseconds(0);

  const dataFine2 = new Date();
  if (dataFine) dataFine2.setDate(dataFine.getDate());
  dataFine2.setUTCHours(0);
  dataFine2.setUTCMinutes(0);
  dataFine2.setSeconds(0);
  dataFine2.setMilliseconds(0);

  const { isLoading, data } = useQuery<unknown, AxiosError, Data[]>(
    ["prenotazioni/getPrenotazioni", dataInizio, dataFine],
    () =>
      axios
        .post(
          API_URL +
            "prenotazioni/getPrenotazioni/" +
            dataInizio2?.toISOString() +
            "/" +
            dataFine2?.toISOString()
        )
        .then((res) => res.data),
    {
      enabled:
        dataInizio !== null &&
        dataFine !== null &&
        dataInizio.getTime() > 1 &&
        dataFine.getTime() > 1,
    }
  );

  const rows = data ?? [];

  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState<keyof Data>("idPrenotazione");
  const [page, setPage] = React.useState(0);
  const dense = oraPrenotaStore((state) => state.tabelleCompatte);
  const [rowsPerPage, setRowsPerPage] = React.useState(25);

  const [viewId, setViewId] = useState<number>();
  const [openView, setOpenView] = useState(false);

  const handleClickOpenView = () => setOpenView(true);
  const handleCloseView = () => {
    setOpenView(false);
    setViewId(undefined);
  };

  const viewPrenotazione = (id: number) => {
    setViewId(id);
    handleClickOpenView();
  };

  const handleRequestSort = (event: React.MouseEvent<unknown>, property: keyof Data) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [filters, setFilters] = useState({});
  const handleFilterRequest = (
    event: React.MouseEvent<unknown>,
    property: keyof Data,
    filter: string | number
  ) => {
    setFilters({
      ...filters,
      [property]: filter,
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const setTitle = uiStore((state) => state.setTitle);
  useEffect(() => {
    setTitle("Dove e quanto");
  }, [setTitle]);

  if (isLoading) return <Loading />;

  return (
    <>
      <Stack gap={3} direction="row">
        <DatePicker
          label="Data Inizio"
          value={dataInizio}
          onChange={(newValue) => {
            setDataInizio(newValue);
          }}
          renderInput={(params) => <TextField {...params} variant="standard" />}
        />

        <DatePicker
          label="Data Fine"
          value={dataFine}
          onChange={(newValue) => {
            setDataFine(newValue);
          }}
          renderInput={(params) => <TextField {...params} variant="standard" />}
        />
      </Stack>
      <Box sx={{ width: "100%" }}>
        <TableContainer>
          <Table size={dense ? "small" : "medium"}>
            <EnhancedTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              onFilter={handleFilterRequest}
            />
            <TableBody classes={{ root: "table-body" }}>
              {stableSort(rows, getComparator(order, orderBy), filters)
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  return (
                    <TableRow hover tabIndex={-1} key={row.idPrenotazione}>
                      <TableCell sx={{ width: "20px" }}>
                        <IconButton
                          onClick={() => viewPrenotazione(row.idPrenotazione)}
                          sx={{ p: 0 }}
                          color="primary"
                        >
                          <InfoIcon />
                        </IconButton>
                      </TableCell>
                      <TableCell>{row.idPrenotazione}</TableCell>
                      <TableCell>{row.denominazione}</TableCell>
                      <TableCell>
                        {format(readDate(row.dataInizioPrenotazione), "dd/MM/yyyy")}
                      </TableCell>
                      <TableCell>{format(readDate(row.dataInizioPrenotazione), "HH:mm")}</TableCell>
                      <TableCell>{format(readDate(row.dataFinePrenotazione), "HH:mm")}</TableCell>
                      <TableCell>{row.codiceSocio}</TableCell>
                      <TableCell>
                        {row.cognome} {row.nome}
                      </TableCell>
                      <TableCell>{row.descrizioneUso}</TableCell>

                      <TableCell>{format(readDate(row.dataInserimento), "dd/MM/yyyy")}</TableCell>
                    </TableRow>
                  );
                })}
              {emptyRows > 0 && (
                <TableRow
                  style={{
                    height: (dense ? 33 : 53) * emptyRows,
                  }}
                >
                  <TableCell colSpan={6} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>

      <Dialog open={openView} onClose={handleCloseView} fullScreen={fullScreen}>
        {viewId && <ViewPrenotazione key={viewId} handleClose={handleCloseView} id={viewId} />}
      </Dialog>
    </>
  );
}
